import type { MarketingDocContent } from '../types';

/** Sourced from backend `privacy-policy/privacyPolicy.html` (legacy visime.ch / app policy). */
export const datenschutzDe: MarketingDocContent = {
  slug: 'datenschutz',
  title: 'Datenschutzerklärung',
  updated: '2018-11-19',
  description: 'Informationen zur Erhebung und Verwendung personenbezogener Daten bei VisiMe.',
  sections: [
    {
      heading: 'Geltungsbereich',
      paragraphs: [
        'LEBO Apps GmbH («wir», «uns») betreibt die mobile Anwendung VisiMe (der «Dienst»). Diese Datenschutzerklärung informiert Sie über unsere Richtlinien hinsichtlich der Erhebung, Verwendung und Offenlegung personenbezogener Daten, wenn Sie unseren Dienst nutzen.',
        'Mit der Nutzung des Dienstes stimmen Sie der Erhebung und Verwendung von Informationen gemäss dieser Richtlinie zu.',
      ],
    },
    {
      heading: 'Welche Daten wir erheben',
      paragraphs: ['Wir erheben verschiedene Arten von Informationen, um den Dienst bereitzustellen und zu verbessern:'],
      list: [
        'Personenbezogene Daten: z. B. E-Mail-Adresse, Vor- und Nachname',
        'Nutzungsdaten: automatisch erfasste Informationen über Gerätetyp, Betriebssystem, IP-Adresse und Nutzungsdauer',
        'Cookies und ähnliche Technologien zur Betrieb und Analyse des Dienstes',
      ],
    },
    {
      heading: 'Verwendung der Daten',
      paragraphs: ['Wir verwenden die erhobenen Daten unter anderem, um:'],
      list: [
        'den Dienst bereitzustellen und aufrechtzuerhalten',
        'Sie über Änderungen am Dienst zu informieren',
        'Kundendienst zu leisten und den Dienst zu verbessern',
        'technische Probleme zu erkennen und zu beheben',
        '— sofern Sie dem nicht widersprochen haben — Informationen zu ähnlichen Produkten und Dienstleistungen zu senden',
      ],
    },
    {
      heading: 'Weitergabe und Speicherort',
      paragraphs: [
        'Ihre Informationen können in Länder ausserhalb Ihres Wohnsitzstaates übertragen und dort verarbeitet werden. Wenn Sie ausserhalb der Schweiz auf den Dienst zugreifen, kann eine Übermittlung in die Schweiz erfolgen.',
        'Wir geben personenbezogene Daten weiter, wenn dies gesetzlich erforderlich ist oder zum Schutz unserer Rechte, der Sicherheit der Nutzer oder der Öffentlichkeit dient.',
      ],
    },
    {
      heading: 'Dienstleister und Analysen',
      paragraphs: [
        'Wir können Drittanbieter zur Erbringung des Dienstes, zur Zahlungsabwicklung oder zur Analyse einsetzen (z. B. Firebase/Google Analytics). Diese erhalten Zugriff auf Daten nur, soweit zur Aufgabenerfüllung erforderlich.',
        'Zahlungsinformationen von Karten werden nicht von uns gespeichert; die Verarbeitung erfolgt über Apple App Store bzw. Google Play gemäss deren Datenschutzrichtlinien.',
      ],
    },
    {
      heading: 'Sicherheit und Kinder',
      paragraphs: [
        'Wir setzen angemessene technische und organisatorische Massnahmen ein, können jedoch keine absolute Sicherheit garantieren.',
        'Der Dienst richtet sich nicht an Personen unter 18 Jahren. Wir erheben wissentlich keine personenbezogenen Daten von Kindern ohne elterliche Einwilligung.',
      ],
    },
    {
      heading: 'Ihre Rechte und Kontakt',
      paragraphs: [
        'Sie können Cookies in Ihrem Browser deaktivieren; einzelne Funktionen stehen dann ggf. nicht zur Verfügung.',
        'Bei Fragen zu dieser Datenschutzerklärung: apps@lebo-apps.ch',
        'Wir können diese Erklärung aktualisieren; massgeblich ist die auf dieser Seite veröffentlichte Fassung.',
      ],
    },
  ],
};
